import { Dispatch, SetStateAction, useCallback, useState } from "react";

interface Actions<T> {
  push: (element: T) => void;
  pop: () => void;
  peek: () => T;
  setStack: Dispatch<SetStateAction<T[]>>;
}

export function useStack<T>(initialStack: T[] = []): [T[], Actions<T>] {
  const [stack, setStack] = useState(initialStack);

  const push = useCallback(
    (element: T) => {
      const stackCopy = [...stack];
      stackCopy.push(element);
      setStack(stackCopy);
    },
    [stack],
  );

  const pop = useCallback(() => {
    const stackCopy = [...stack];
    stackCopy.pop();
    setStack(stackCopy);
  }, [stack]);

  const peek = useCallback(() => {
    return stack[stack.length - 1];
  }, [stack]);

  return [stack, { peek, pop, push, setStack }];
}
